import { render, staticRenderFns } from "./ProjectsList.vue?vue&type=template&id=6c5f0d36&scoped=true"
import script from "./ProjectsList.vue?vue&type=script&lang=ts"
export * from "./ProjectsList.vue?vue&type=script&lang=ts"
import style0 from "./ProjectsList.vue?vue&type=style&index=0&id=6c5f0d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5f0d36",
  null
  
)

export default component.exports